import '@fortawesome/fontawesome-pro/css/all.css';

import Vue from 'vue';
import Vuex from 'vuex';

import App from './App';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/bugsnag';
import './plugins/currencyFilter';
import './plugins/moment';

Vue.use(Vuex);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
